import * as React from "react";
import {Field} from "react-final-form";
import {TiposCliente} from "../../documentos/modelo/TiposCliente";

export default class TipoCliente extends React.Component<TipoClienteProps> {

    render() {
        const {className, excluir, disabled} = this.props;
        const tiposClientes = this.filtrarTiposCliente(excluir);
        return (
            <Field
                component="select"
                name={this.props.name}
                disabled={disabled}
                className={className ? className.concat(" form-control") : "form-control"}>
                <option value={""}>Selecciona...</option>
                {tiposClientes.map(tipo => {
                    return <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>;
                })}
            </Field>
        );
    }

    filtrarTiposCliente = (excluir: Array<string>) => {
        return TiposCliente.filter(tc => {
            return !excluir || excluir.indexOf(tc.id) === -1;
        });
    }
}

interface TipoClienteProps {
    name: string,
    className?: string,
    excluir?: Array<string>,
    disabled?: boolean
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/general/componentes/TipoCliente.tsx